// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3W8jF","buttons":"PendingPaymentAlert_buttons__vy25t"};